(() => {
  'use strict';
  const instances = new Map();
  const reviewBodies = '.jm-review-content__body, .jdgm-rev__body';
  function repair(scope) {
    if (!scope || scope.nodeType !== 1) return;
    const bodies = scope.matches(reviewBodies) ? [scope] : [...scope.querySelectorAll(reviewBodies)];
    bodies.forEach(body => {
      const walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const original = node.nodeValue;
        const fixed = original.replace(/(tiger)\uFFFD{1,3}(s eye)/gi, '$1’$2');
        if (fixed !== original) node.nodeValue = fixed;
      }
    });
  }
  function init(root) {
    if (instances.has(root)) return;
    repair(root);
    const observer = new MutationObserver(records => {
      const scopes = new Set();
      records.forEach(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        const body = target?.closest(reviewBodies);
        if (body) scopes.add(body);
        record.addedNodes.forEach(node => {if (node.nodeType === 1) scopes.add(node);});
      });
      scopes.forEach(repair);
    });
    observer.observe(root, {subtree:true, childList:true, characterData:true});
    instances.set(root, observer);
  }
  function scan(scope) {
    if (scope.matches?.('#judgeme_product_reviews')) init(scope);
    scope.querySelectorAll('#judgeme_product_reviews').forEach(init);
    for (const [root, observer] of instances) {
      if (!root.isConnected) {observer.disconnect();instances.delete(root);}
    }
  }
  function start() {
    const main = document.getElementById('MainContent');
    if (!main) return;
    scan(main);
    const observer = new MutationObserver(records => {
      records.forEach(record => record.addedNodes.forEach(node => {if (node.nodeType === 1) scan(node);}));
      scan(main);
    });
    observer.observe(main, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, observer] of instances) {
      if (event.target === root || event.target.contains(root)) {observer.disconnect();instances.delete(root);}
    }
  });
})();
